<template>
	<div class="news">
		<div class="contanier">
			<div class="section-title">
				<h2>新闻资讯</h2>
				<p>了解行业最新资讯 了解印刷知识 服务更有保障</p>
			</div>
			<ul v-for="(art,index) in artilces" :key="index">
				<li v-for="item in art" :key="item.id">
					<router-link :to="{path:'/article',query:{id:item.id}}" class="a-item">
						<div class="new-img" v-if="item.img">
							<img :src="item.img" :alt="item.title">
						</div>
						<div class="new-img" v-else>
							<img src="../assets/image/no.jpg">
						</div>
						<div class="news-info">
							<h2>{{item.title}}</h2>
							<div class="news-time">{{item.addtime}}</div>
							<div class="news-desc" v-html="item.description"></div>
						</div>
					</router-link>
				</li>
			</ul>

			<div class="more" v-if="totalPage-page>0" @click="getMoreArticle()">-- 点击加载更多 --</div>

		</div>

	</div>


</template>

<script>
	export default {
		data: () => {
			return {
				artilces: [],
				page: 1,
				totalPage: 1,
				size: 20,
			
			}
		},
		mounted() {
			//获取服务器数据
			var page = this.page;
			console.log(page);
			if (page <= this.totalPage) {
				this.page = page;
				this.axios.get("getAllArticle", {
					params: {
						page: page,
						size: this.size
					}
				}).then(res => {
					console.log(res);
					if (res.data.code == 'success') {
						this.artilces.push(res.data.data.article)
						this.articleCount = res.data.data.count;
						this.totalPage = res.data.data.totalPage;
					}
				})
			}
		},

		methods: {
			getMoreArticle() {
				var page = this.page + 1;
				if (page <= this.totalPage) {
					this.page = page;
		
					this.axios.get("getAllArticle", {
						params: {
							page: page,
							size: this.size
						}
					}).then(res => {
						
	
						if (res.data.code == 'success') {
							this.artilces.push(res.data.data.article)
							this.articleCount = res.data.data.count;
							this.totalPage = res.data.data.totalPage;
						}
					})
				}
			}
		}

	}
</script>

<style>
	.news {
		min-height: 490px;
		position: relative;
	}

	.more {
		text-align: center;
		font-size: 14px;
		position: absolute;
		bottom: 10px;
		left: 0;
		right: 0;
		color: #666;
	}

	/* .loading {
		text-align: center;
	} */
</style>
